import JumboTab from './JumboTab';

export default JumboTab;
